var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 263,
    viewBox: "0 0 339 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.749 265.149C277.708 346.964 150.137 360.072 42.8125 294.428C-64.5123 228.783 -110.95 109.244 -60.9086 27.4295C-10.8673 -54.385 34.3323 67.1781 141.657 132.823C248.982 198.467 377.79 183.335 327.749 265.149Z",
    fill: "#873FE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse22);
export default __webpack_public_path__ + "static/media/Ellipse 22.65b8ae73ca96f225813a084c41271206.svg";
export { ForwardRef as ReactComponent };